import _get from 'lodash/get';
var styles = function styles(theme) {
  return {
    compactFooterWrap: {
      marginTop: '50px',
      padding: '15px 0'
    },
    blockRow: {
      padding: '0 16px'
    },
    blockRowContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    copyRightText: {
      width: '33%',
      justifyContent: 'center',
      textAlign: 'center'
    },
    paymentCards: {
      width: '33%',
      display: 'flex',
      justifyContent: 'flex-end'
    },
    phoneNumber: {
      display: 'flex',
      alignItems: 'center',
      width: '33%',
      '& svg': {
        marginRight: 10
      }
    },
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.gainsboro.main),
      marginBottom: 15
    }
  };
};
export default styles;